export const ROLES = Object.freeze({
    ADMIN: 1,
    TAGGER: 3,
    REVIEWER: 4,
    MANAGER: 2,
  });